export default "__VITE_ASSET__B8q0qKo4__"